import clsx from 'clsx'
import { CircleOff, RefreshCcw } from 'lucide-react'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

type BigNumberCardProps = PropsWithChildren<{
  className?: string
  loading?: boolean
  error?: boolean
  empty?: boolean
  onRefetchClick?: () => void
}>

function BigNumberCard (props: BigNumberCardProps) {
  const { loading, error, empty, onRefetchClick } = props
  const { t } = useTranslation()

  return (
    <div className={clsx(
      'rounded-xl flex flex-col w-full gap-2 border-2 bg-white overflow-hidden min-h-32',
      !error && !empty && !loading && 'px-8 py-6 items-center justify-center',
      error && !empty && !loading && 'text-red-500 opacity-70',
      !error && !empty && !loading && '!items-center',
      props.className
    )}
    >
      {!error && !empty && !loading && (props.children)}
      {empty && !error && !loading && (
        <div className="flex items-center gap-1 justify-center min-h-32 h-full bg-base-200/30">
          <CircleOff size={16} className='text-gray-500' />
          <h2 className="text-md text-gray-500">{t('workspaceUsagePage:No data')}</h2>
        </div>
      )}
      {error && !empty && !loading && (
        <div className='bg-red-50 h-full min-h-32 flex justify-center items-center gap-2'>
          <span>{t('common:Error fetching data')}</span>
          <button className='btn btn-sm btn-ghost btn-circle' onClick={onRefetchClick}>
            <RefreshCcw className="text-black" size={16} />
          </button>
        </div>
      )}
      {!error && !empty && loading && (
        <div className="flex items-stretch justify-center min-h-32 w-full h-full bg-base-200/30">
          <div className="skeleton w-full" />
        </div>
      )}
    </div>
  )
}

function BigNumberCardNumber (props: PropsWithChildren) {
  return <div className="flex font-bold text-3xl text-black">{props.children}</div>
}

function BigNumberAdditionalInfo (props: PropsWithChildren) {
  return <div className="opacity-70 text-sm">{props.children}</div>
}

export const BigNumber = {
  Card: BigNumberCard,
  Number: BigNumberCardNumber,
  AdditionalInfo: BigNumberAdditionalInfo
}
